import React from 'react';
import { AText, Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import { LiveDataBetsSectionProps } from './types';
import { useLiveDataPreparedFormattedBetsString } from './useLiveDataPreparedFormattedBetsString';

import styles from './index.module.css';

export const LiveDataBetsSection = ({
  minBet,
  maxBet,
  isGameCardMinimised,
  currencySymbol
}: LiveDataBetsSectionProps) => {
  const preparedFormattedBetsString = useLiveDataPreparedFormattedBetsString({
    minBet,
    maxBet,
    isGameCardMinimised,
    currencySymbol
  });
  return (
    <Box className={styles.liveDataItem}>
      <Box className={styles.liveDataIconWrapper}>
        <Icon
          size="s"
          name="icons/general/state/stake-sum1"
          color="txt_color_4"
        />
      </Box>
      <AText
        color="txt_color_4"
        breed="R"
        size={isGameCardMinimised ? 'xs' : 's'}
      >
        {preparedFormattedBetsString}
      </AText>
    </Box>
  );
};
